import React from "react";
import PropTypes from "prop-types";
// https://developers.google.com/search/docs/data-types/article#logo-guidelines
import logo from "../../images/logo_60pxheight.jpeg";

class JsonLD extends React.Component {
  static createStructure(siteMetadata) {

    /*
     * Article type example taken from:
     * https://search.google.com/structured-data/testing-tool
     *
     * Reference:
     * http://schema.org/Organization
     * https://developers.google.com/search/docs/data-types/social-profile
     * https://www.hallaminternet.com/implementing-json-ld-structured-data/
     */
    return {
      "@type": "Organization",
      name: siteMetadata.title,
      url: siteMetadata.siteUrl,
      logo: {
        "@type": "ImageObject",
        height: 60,
        url: `${siteMetadata.siteUrl}${logo}`
      },
      sameAs: [
        siteMetadata.social.twitter,
        siteMetadata.social.linkedin,
        siteMetadata.social.github
      ]
    };
  }

  render() {
    const { siteMetadata } = this.props,
      structuredData = JsonLD.createStructure(siteMetadata);

    structuredData["@context"] = "http://schema.org";

    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    );
  }
}

JsonLD.propTypes = {
  siteMetadata: PropTypes.shape({
    siteUrl: PropTypes.string.isRequired,
    social: PropTypes.shape({
      twitter: PropTypes.string.isRequired,
      linkedin: PropTypes.string.isRequired,
      github: PropTypes.string.isRequired
    }),
    title: PropTypes.string.isRequired
  })
};

export default JsonLD;



// WEBPACK FOOTER //
// ./src/components/JsonLD/organisation.jsx